module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Billionaire's Bride of Innocence")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm04"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("PROLOGUE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("EGAN")])]), _vm._v(" lay on her side in the hard, narrow hospital bed, hoping and praying that the injection the doctor had given her would start working soon. She could not bear to be awake for much longer. Could not bear the pain of her loss for another minute.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Yesterday she had been so happy, the ultrasound showing that she and James were to become the parents of a dear little boy. She’d been over the moon. So had James.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("His lovemaking last night had been extra gentle and tender. They’d talked for ages afterwards, discussing what names they would give their son. They’d finally settled on Jonathon, after James’s older brother, who’d been tragically killed in a car accident some years earlier.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("The cramps had started during the early hours of this morning. Then had come the bleeding. James had rushed her to the hospital and the doctors had done their best. But nothing could save her baby.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Tears flooding her eyes once more, Megan pressed a smothering fist into her trembling mouth when a sob threatened to escape. She didn’t want anyone to hear her weeping. She didn’t want to listen to any more words of comfort, or sympathy. All she wanted was oblivion. So she bit down on her knuckles and endured her grief in tormented silence.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Time dragged. So did Megan’s heart.")])])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Finally, the sedative did its work and she drifted off to sleep. She did not see her husband re-enter the room a short time later. Did not see the distress on his face as he stared down at his sleeping wife. With a sigh he stroked her hair back from her face, then bent to kiss her softly on the cheek. Shaking his head, he straightened then strode from the room.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("It was some considerable time before Megan stirred. Even then, her eyes stayed shut, her head feeling thick and heavy. She could hear voices in the room: male voices—gradually she recognised them as belonging to her husband’s two best friends.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘James has been out there talking to that doctor for a long time,’ Hugh said irritably.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Hugh Parkinson was the only son and heir to a media fortune. Although he was a playboy by reputation, Megan had always found him rather sweet. He’d been best man at her wedding and had made the loveliest of speeches.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘He’s probably worried about Megan’s condition,’ Russell answered. Russell McClain was one of Sydney’s most successful real-estate agents.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("The three men had been best friends since they’d shared a room at boarding school. And, whilst they had little in common besides their wealth and their love of golf, their friendship had endured for over twenty years. Megan sometimes envied their unconditional affection for each other. She’d never been a girl to make friends easily, being somewhat shy and introverted.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Huh!’ Hugh snorted. ‘More likely making sure that she can have more babies.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan was shocked, both by the reproach in Hugh’s voice and the inference behind his words. Surely he didn’t think James had only married her because she’d been pregnant! That wasn’t right. James loved her. She knew he did. Why, he told her so all the time!")])])]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘He should never have married that poor girl,’ Hugh raved on. ‘It was wrong. No, damn it, it was downright wicked. Serve him right if she can’t have more kids.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan’s mouth fell open. Why was Hugh being so cruel and so condemning of his friend?")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘That’s a bit harsh, Hugh,’ Russell said.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘No, it’s not. Marriage should be about true love, not satisfying an egotistical need to reproduce.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘There’s nothing wrong with James wanting a family. It’s unfortunate that he doesn’t love Megan, but he "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("is")])]), _vm._v(" very fond of her.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan had almost stopped breathing by this stage, the emotional pain of her miscarriage eclipsed by a shock even more devastating than the loss of her baby. She could survive that loss—eventually—if she had her husband’s love.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("But it seemed she didn’t.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Oh, God…")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘I could forgive him if the girl had conceived by accident,’ Hugh said. ‘Marrying her under those circumstances would have been the honourable thing to do. What I find hard to condone is that he deliberately set out to impregnate her first.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan had to stuff her fist into her mouth to stop herself from crying out. It was just as well she had her back to Russell and Hugh or they might have seen her hand move.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘I can understand why he did that,’ Russell remarked. ‘You must remember what he was like when he found out Jackie was barren. The poor bastard was beside himself.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Barren!")])]), _vm._v(" His first wife was "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("barren?")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("James had told her his first marriage had ended because Jackie, an Australian supermodel, wanted a jet-setting lifestyle, whereas he wanted a normal family life. He’d claimed they’d been drifting apart for ages and had split up by mutual consent. It was obvious, however, from what his friends were saying, that James had divorced Jackie because she couldn’t have children.")])])]), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan desperately tried to find some mitigating circumstances against such a ruthless course of action. Maybe they "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" been drifting apart. They couldn’t have been madly in love, or James would surely have suggested adoption. Unless, of course, he was one of those egotistical men who only wanted a child who carried his own genes. Hugh had implied as much.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘I could forgive the man if he’d chosen a tough bird like Jackie,’ Hugh growled. ‘But, of course, that wouldn’t do the second time round, would it? James had to regain total control of his life. So he zeroed in on an innocent young virgin who was so swept off her feet by the dashing James Logan that she wasn’t able to see the wood for the trees.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘You don’t know Megan was a virgin,’ Russell pointed out. ‘She "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("is")])]), _vm._v(" twenty-four. Not too many twenty-four-year-old virgins around these days.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Oh, for pity’s sake, Russ, you only have to look at the way she acts around James to know he was her first lover. She’s utterly besotted with him. He could tell her the world was flat and she’d believe him.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan cringed, whilst Russell sighed.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Probably,’ he said. ‘But that doesn’t mean James won’t make a good husband and father. He’s a bit ruthless at times, but still basically a good man. And a good friend. We have no right to judge him, Hugh, we’re far from being perfect. And it’s not as though Megan knows the truth.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘But what if she finds out?’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Who’s going to tell her? Not us, that’s for sure.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("No, Megan thought wretchedly. You wouldn’t tell me. Not even you, Hugh, who obviously didn’t approve of James’s actions. Both of you stood up at my wedding and bore witness to James promising to love, honour and cherish me when you knew it was all a lie.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan froze when she heard the door open, followed by the sound of her husband’s voice.")])])]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Sorry to be so long,’ he said to his friends. ‘Megan still asleep?’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Hasn’t moved a muscle,’ Russell replied. ‘What did the doctor say?’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘There’s no reason why, in time, Megan can’t have another baby. But he cautioned not to rush things. He said it’s going to take quite a while for her to get over this. She’s taken it very hard.’ He sighed a weary sigh. ‘We both have. It was a boy, you know,’ he went on somewhat croakily. ‘We were going to call him Jonathon…’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan hated hearing the distress in her husband’s voice. Hated the fact that she could still sympathise with his pain.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘I’m sorry, mate,’ Hugh said, all condemnation clearly gone now. ‘We do know how much having children means to you. You must be feeling really rotten. Come on, we’ll take you for a drink. There’s a pub just down the road.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘I’ll have to check on Megan first.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Sure thing.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Megan felt the warmth of his breath on her cheek as he bent over her.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Megan, darling, can you hear me?’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Why, oh, why did she open her eyes?")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘How are you feeling?’ he asked her gently.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("Her eyes filled with tears as she stared up into the face of the man she loved, and who she’d thought loved her.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Go away,’ she choked out. ‘Please…just go away!’ The sobs came in earnest then, shoulder-wracking, heartbreaking sobs. She simply could not stop.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘I’ll get the nurse,’ he said.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("The nurse hurried in, a kind, motherly creature who took Megan in her arms and just held her.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘There, there, dear,’ she crooned. ‘I know how you feel. I lost a baby once.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("But I’ve lost more than that, Megan agonised. I’ve lost everything!")])])]), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("And she sobbed all the louder.")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("‘Best leave her for now,’ the nurse directed at James, who was obviously hovering near by. ‘I’ll get the doctor to give her something stronger. She’ll be out of it for some time. Come back this evening. Hopefully, she’ll be feeling better by then.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("No, I won’t, Megan thought despairingly. I’m never going to feel better. Never!")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-455a96cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/billionairesbrideofinnocencethe_fm04.vue
// module id = 72
// module chunks = 0